<template>
  <div class="confirm-block">
    <div v-if="!value.error" class="confirm-block__image confirm">
      <svg
        width="92"
        height="92"
        viewBox="0 0 92 92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="46" cy="46" r="46" fill="#BFC9D8" />
        <path
          d="M28 50L37.5 59.5L65 32"
          stroke="#EDF1F7"
          stroke-width="3"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div v-else class="confirm-block__image error">
      <svg
        width="92"
        height="92"
        viewBox="0 0 92 92"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="46" cy="46" r="46" fill="#FBBBBB" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M47.932 45.8107L60.6213 33.1213L58.5 31L45.8107 43.6893L33.1213 31L31 33.1213L43.6893 45.8107L31 58.5L33.1213 60.6213L45.8107 47.932L58.5 60.6213L60.6213 58.5L47.932 45.8107Z"
          fill="#EDF1F7"
        />
      </svg>
    </div>
    <h3 class="confirm-block__title">{{ value.title }}</h3>
    <p class="confirm-block__text">{{ value.text }}</p>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
.confirm-block
  &__image
    display: flex
    margin-bottom: 32px
  &__title
    font-size: 32px
    line-height: 35px
    margin-bottom: 16px
  &__text
    font-size: 14px
    line-height: 18px

  @media screen and ( max-width: 1279px)
    height: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    &__title
      text-align: center
  @media screen and ( max-width: 1023px)
    &__text
      text-align: center
      max-width: 180px
</style>



// WEBPACK FOOTER //
// src/templates/components/right-menu/ui/confirmBlock.vue